import { useCallback } from "react";
import { ref, set, remove } from "firebase/database";
import { db } from "../api/firebase";
import { useAuth } from "../helpers/Auth";
import { useNavigate } from "react-router";
import uuid from "react-uuid";
import { parseRateValue, parseSegmentNumber } from "../helpers/unitHelpers";

// Coerce form values into the numeric shape the rest of the app expects.
// "AFAP" is silently translated to 9999 here so that legacy free-text rates
// never reach the database.
const normalizeSegment = (formProps: any) => ({
  ...formProps,
  rate: parseRateValue(formProps.rate),
  temperature: parseSegmentNumber(formProps.temperature),
  hold: parseSegmentNumber(formProps.hold),
});

const useSegmentActions = () => {
  const { effectiveUID } = useAuth();
  const navigate = useNavigate();

  const userPath = () => `/userdata/${effectiveUID}`;

  const createSegment = useCallback(
    (formProps: any, allowNavigate: boolean = true) => {
      const payload = normalizeSegment(formProps);
      payload.id = uuid();
      set(ref(db, userPath() + `/segments/${payload.id}`), {
        ...payload,
      });
      if (allowNavigate) {
        navigate(-1);
      }
    },
    [effectiveUID, navigate]
  );

  const editSegment = useCallback(
    (id: string, formProps: any, allowNavigate: boolean = true) => {
      const payload = normalizeSegment(formProps);
      payload.id = id;
      set(ref(db, userPath() + `/segments/${id}`), {
        ...payload,
      });
      if (allowNavigate) {
        navigate(-1);
      }
    },
    [effectiveUID, navigate]
  );

  const deleteSegment = useCallback(
    (id: string, allowNavigate: boolean = true) => {
      remove(ref(db, userPath() + `/segments/${id}`));
      if (allowNavigate) {
        navigate(-1);
      }
    },
    [effectiveUID, navigate]
  );

  return { createSegment, editSegment, deleteSegment };
};

export default useSegmentActions;
